import { Component, NgIterable, OnInit } from '@angular/core';
import { FileService } from './file.service';
import { Router } from '@angular/router';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
import { GlobalConstants } from '../config/GlobalConstants';
import { environment } from 'src/assets/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/Services/shared.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OktaLoginService } from '../loginServices/OktaLogin.service';

@Component({
    selector: 'app-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    standalone: false
})
export class ViewComponent implements OnInit {
  public gmplogoimg!: string;
  public selectedLanguage: string = "English";
  fileNotFound: string;
  ackMsg: string;
  pdfSource: SafeResourceUrl | undefined;
  videoSource: SafeResourceUrl | undefined;
  
  constructor(private oktaLoginService: OktaLoginService,
    public translate: TranslateService,
    private fileDownloadService: FileService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer
  ) {
    //Adding translation suported languages
    translate.addLangs(['English', 'French']);
    let userPrefernceLanguage = sessionStorage.getItem("UserPrefernceLanguage") ?? this.selectedLanguage;
    translate.setDefaultLang(userPrefernceLanguage);
    sessionStorage.setItem("UserPrefernceLanguage", userPrefernceLanguage);
    document.documentElement.lang = userPrefernceLanguage;
    this.selectedLanguage = userPrefernceLanguage;
    this.activateImages();
  }

  ngOnInit(): void {
      let access_token = sessionStorage.getItem('access_token'),
        headers: HttpHeaders = new HttpHeaders({
          "Authorization": "Bearer " + access_token,
          "Accept": "application/json",
          "idToken": sessionStorage.getItem('id_token')!
        });
        
    this.fileDownloadService.getAllFiles(headers).subscribe({
      next: (response) => {
        this.files = response as any[];
              this.filterFilesByCategory();
      },
      error: (error) => {
        console.error("Error fetching files:", error);
      }
    });

    this.gmplogoimg = this.activateImages();
    this.switchLang(this.selectedLanguage);
    this.defaultMessages();
  }

  defaultMessages() {
    this.fileNotFound = GlobalConstants.fileNotFound;
    this.ackMsg = GlobalConstants.ackMsg;
  }

  async viewPdf(selectedMediaType:any) {
    console.log("Selected Media Type:", selectedMediaType);
    this.defaultMessages();

      let access_token = sessionStorage.getItem('access_token'),
        headers: HttpHeaders = new HttpHeaders({
          "Authorization": "Bearer " + access_token,
          "Accept": selectedMediaType.mmType === 'Videos' ? "application/json" : "application/pdf",
          "Content-Type": selectedMediaType.mmType === 'Videos' ? "application/json" : "application/pdf",
          "idToken": sessionStorage.getItem('id_token')!
        });
      let queryParams = new HttpParams();
      queryParams = queryParams.append("mmType", selectedMediaType.mmType);
      queryParams = queryParams.append("language", selectedMediaType.language);
      queryParams = queryParams.append("brandName", selectedMediaType.brand);
      queryParams = queryParams.append("productType", selectedMediaType.productType);
      this.spinner.show();
      const responseType: 'json' | 'blob' = selectedMediaType.mmType === 'Videos' ? 'json' : 'blob';

      this.fileDownloadService.download(headers, queryParams, responseType).subscribe({
        next: c => {
          if (selectedMediaType.mmType === 'Videos') {
            // Handle video response
            let videoUrl = c.fileName || c.url || c;
            
            // If it's a relative path, construct the full URL
            if (videoUrl && !videoUrl.startsWith('http')) {
              const baseUrl = window.location.href.includes(GlobalConstants.extPath) ? environment.baseUrlExt : environment.baseUrlInt;
              videoUrl = baseUrl + '/' + videoUrl.replace(/^\/+/, '');
            }
            
            this.videoSource = this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
            
            // Show the video modal immediately
            this.showVideoModal();
          } else {
            const newBlob = new Blob([c], { type: 'application/pdf' });
            const url = URL.createObjectURL(newBlob);
            this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            
            // Show the PDF modal immediately
            this.showPdfModal();
          }
        },
        error: error => {
          this.spinner.hide();
          if (selectedMediaType.mmType === 'Videos' && error.status === 404) {
            // For video errors, show the modal with empty source
            this.videoSource = undefined;
            this.showVideoModal();
            this.langValidation(GlobalConstants.fileNotFoundFrench, GlobalConstants.ackMsgFrench);
            this.FailureNotification(this.fileNotFound, this.ackMsg);
          } else {
            this.langValidation(GlobalConstants.fileNotFoundFrench, GlobalConstants.ackMsgFrench);
            this.FailureNotification(this.fileNotFound, this.ackMsg);
          }
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    
  }



  langValidation(errorText: string, ackMsg: string) {
    if (document.documentElement.lang == "French") {
      this.fileNotFound = errorText;
      this.ackMsg = ackMsg;
    }
  }

  FailureNotification(successText: string, ackMsg: string) {
    Swal.fire({
      text: successText,
      icon: 'error',
      showCancelButton: false,
      confirmButtonText: ackMsg,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: GlobalConstants.buttonColorCode,
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['/home'])
      }
    });
  }
  public activateImages() {
    if (document.documentElement.lang == "French") {
      this.gmplogoimg = "/assets/images/gmProtectionsLogo_French.jpg";
    } else {
      this.gmplogoimg = "/assets/images/gmProtectionsLogo.jpg";
    }
    return this.gmplogoimg;
  }

  switchLang(lang: string) {
    this.selectedLanguage = lang;

    this.translate.use(lang);
    document.documentElement.lang = lang;
    sessionStorage.setItem("UserPrefernceLanguage", lang);
    this.activateImages();
    // Re-filter files to update search results with new language
    if (this.files && this.files.length > 0) {
      this.filterFilesByCategory();
    }
  }

  filteredFiles: any[] = [];
  paginatedFiles: any[] = [];
  files: any[] = [];
  sortDirection: string = 'asc';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  sortColumn: string = '';
  searchMediaType: string = '';
  searchBrand: string = '';
  searchProduct: string = '';
  searchDescription: string = '';
  searchLanguage: string = '';
  searchTimestamp: string = '';

    sortFiles(column: string): void {
    this.updateSortDirection(column);
    this.filteredFiles.sort((a, b) => this.compareValues(a, b, column));
    this.updatePagination();
  }

    updatePagination(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedFiles = this.filteredFiles.slice(start, end);
  }

  updateSortDirection(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }

    compareValues(a: any, b: any, column: any): number {
    const aValue = this.getValue(a, column);
    const bValue = this.getValue(b, column);
    if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
    } else if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
    } else {
        return 0;
    }
}

 getValue(file: any, column: string): any {
    console.log(`Getting value for column: ${column}`);
    console.log(file);
   
    // Return translated values for sorting to match what users see
    switch (column) {
      case 'mmType':
        return this.translateMediaType(file[column]);
      case 'brand':
        return this.translateBrand(file[column], file.mmType);
      case 'productType':
        return this.translateProductType(file[column], file.brand, file.mmType);
      case 'language':
        return this.translateLanguage(file[column]);
      default:
        return file[column as keyof any];
    }
}

 filterFilesByCategory(): void {
    this.filteredFiles = this.files.filter(file => {
        // Only show records matching the currently selected page language (English/French)
        const selectedLangCode = this.selectedLanguage === 'French' ? 'FR' : 'EN';
        const pageLanguageMatch = file.language?.toUpperCase() === selectedLangCode;

        // For media type, search both original key and translated value
        const mediaTypeMatch = !this.searchMediaType ||
            this.translateMediaType(file.mmType).toLowerCase().includes(this.searchMediaType.toLowerCase());
 
        // For brand, search both original key and translated value (with context)
        const brandMatch = !this.searchBrand ||
            file.brand?.toLowerCase().includes(this.searchBrand.toLowerCase()) ||
            this.translateBrand(file.brand, file.mmType).toLowerCase().includes(this.searchBrand.toLowerCase());
 
        // For product type, search both original key and translated value (with context)
        const productTypeValue = this.selectedLanguage === 'French'
            ? this.translateProductType(file.productType, file.brand, file.mmType)
            : file.productType;
        const productMatch = !this.searchProduct ||
            (productTypeValue && productTypeValue.toLowerCase().includes(this.searchProduct.toLowerCase()));

 
        // For language, search both original code and translated value
        const languageMatch = !this.searchLanguage ||
            file.language?.toLowerCase().includes(this.searchLanguage.toLowerCase()) ||
            this.translateLanguage(file.language).toLowerCase().includes(this.searchLanguage.toLowerCase());
 
        // Description remains unchanged (no translation needed)
        const descriptionMatch = !this.searchDescription ||
            file.fileDescription?.toLowerCase().includes(this.searchDescription.toLowerCase());
 
        // For timestamp, compare the formatted date string
        const formattedDate = file.timeStamp
            ? new Date(file.timeStamp).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
            : '';
        const timestampMatch = this.searchTimestamp
            ? formattedDate.toLowerCase().includes(this.searchTimestamp.toLowerCase())
            : true;
 
        return pageLanguageMatch && mediaTypeMatch && brandMatch && productMatch && descriptionMatch && languageMatch && timestampMatch;
    });
    this.updatePagination();
}
  changePage(page: any): void {
    this.currentPage = page;
    this.updatePagination();
  }


    showPdfModal() {
    const modalElement = document.getElementById('pdfModal');
    if (modalElement) {
      if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
      } else {
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        modalElement.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
      }
    }
  }

  showVideoModal() {
    const modalElement = document.getElementById('videoModal');
    console.log("Showing video modal");
    if (modalElement) {
      if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
        
        // Add event listener to stop video when modal is hidden
        modalElement.addEventListener('hidden.bs.modal', () => {
          this.stopVideo();
        });
      } else {
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        modalElement.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
      }
    }
  }

  stopVideo() {
    // Clear the video source to stop playback
    this.videoSource = undefined;
    
    // Find any video/object elements and reset them
    const videoModal = document.getElementById('videoModal');
    if (videoModal) {
      const objectElements = videoModal.querySelectorAll('object');
      objectElements.forEach(obj => {
        obj.data = '';
      });
      
      const videoElements = videoModal.querySelectorAll('video');
      videoElements.forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.src = '';
        video.load();
      });
    }
  }

  // Method to translate language codes to display names based on current page language
  translateLanguage(langCode: string): string {
    const currentLang = document.documentElement.lang || this.selectedLanguage;
   
    if (currentLang === 'French') {
      // French translations
      switch (langCode) {
        case 'EN':
          return 'Anglais';
        case 'FR':
          return 'Français';
        default:
          return langCode;
      }
    } else {
      // English translations
      switch (langCode) {
        case 'EN':
          return 'English';
        case 'FR':
          return 'French';
        default:
          return langCode;
      }
    }
  }

  // Method to translate media type based on current language
  translateMediaType(mmTypeKey: string): string {
    const currentLang = document.documentElement.lang || this.selectedLanguage;
    const mediaTypeMap = GlobalConstants.langMap[currentLang] || GlobalConstants.langMap['English'];
   
    // Convert NgIterable to array and find the matching media type
    const mediaTypeArray = Array.from(mediaTypeMap);
    const mediaType = mediaTypeArray.find((media: any) => media.key === mmTypeKey);
    return mediaType ? mediaType.value : mmTypeKey;
  }

  // Method to translate brand based on media type and language
  translateBrand(brandKey: string, mediaTypeKey?: string): string {
    const currentLang = document.documentElement.lang || this.selectedLanguage;
    let brandTypeMap: NgIterable<any> = [];
    
    // Use the same logic as changeBrandType method
    if (mediaTypeKey === GlobalConstants.COMMUNICATIONS) {
      if (this.sharedService.isFrench(currentLang)) {
        brandTypeMap = GlobalConstants.brandTypeCommunicationsFR;
      } else {
        brandTypeMap = GlobalConstants.brandTypeCommunicationsEN;
      }
    } else {
      const brandTypeMapping: {[key: string]: NgIterable<any>} = {
        "Brochures": GlobalConstants.brandTypeBrochures,
        "Desk_Mats": GlobalConstants.brandTypeDefault,
        "Acrylic_Stand_Insert": GlobalConstants.brandTypeDefault,
        "Videos": GlobalConstants.brandTypeDefault
      };
      brandTypeMap = brandTypeMapping[mediaTypeKey || ''] ?? GlobalConstants.brandTypeDefault;
    }
    
    // Find the matching brand
    const brandArray = Array.from(brandTypeMap);
    const brand = brandArray.find((b: any) => b.key === brandKey);
    return brand ? brand.value : brandKey;
  }
   // Method to translate product type based on current language using same logic as productType service
  translateProductType(productTypeKey: string, brandKey?: string, mediaTypeKey?: string): string {
    const currentLang = document.documentElement.lang || this.selectedLanguage;
    
    let productTypeMap: NgIterable<any> = [];
    
    if (mediaTypeKey === GlobalConstants.ACRYLICSTANDINSERT) {
      productTypeMap = this.sharedService.isEnglish(currentLang) 
        ? GlobalConstants.productTypesAcrylicStandEN 
        : GlobalConstants.productTypesAcrylicStandFR;
    } else if (brandKey !== undefined && GlobalConstants.languageMap[currentLang]) {
      if (GlobalConstants.languageMap[currentLang][brandKey] === undefined && this.sharedService.isEnglish(currentLang)) {
        productTypeMap = GlobalConstants.productTypesEN;
      } else if (GlobalConstants.languageMap[currentLang][brandKey] === undefined && this.sharedService.isFrench(currentLang)) {
        productTypeMap = GlobalConstants.productTypesFR;
      } else {
        productTypeMap = GlobalConstants.languageMap[currentLang][brandKey];
      }
    } else {
      // Fallback to basic translation
      if (currentLang === 'French') {
        productTypeMap = GlobalConstants.productTypesFR;
      } else {
        productTypeMap = GlobalConstants.productTypesEN;
      }
    }
    
    // Find the matching product type
    const productTypeArray = Array.from(productTypeMap);
    const productType = productTypeArray.find((p: any) => p.key === productTypeKey);
    return productType ? productType.value : productTypeKey;
  }
 

}
